



































































































































































import Vue from 'vue';

export default Vue.extend({
    name: 'Select',
    metaInfo: {
        title: 'About',
        meta : [
            {
                name: 'description',
                content : 'This website was developed by the Cyclone Testing Station at James Cook University, Geoscience Australia and the Bushfire and Natural Hazards CRC to provide information to homeowners and builders on the maintenance and retrofitting of older Australian houses for severe wind loads.'
            },
            {
                name: 'keywords',
                content : 'Homeowners, Builders, Cyclone Testing Station, James Cook University, Geoscience Australia, Bushfire and Natural Hazards CRC, retrofitting, cyclone, weather, storm, protection'
            }
        ]
    },
    data: () => ({

    }),
    computed: {

    },
})
